import * as React from 'react';

// mui
import { Box, InputLabel, MenuItem, FormControl, Select } from "@mui/material";

// hooks
import { useState } from 'react';


export default function Selection({ lang, setLat, setLon }) {

    const [age, setAge] = useState("");

    const handleChange = (event) => {
        setAge(event.target.value);
    };

    function handleCity(lat, lon) {
        const currentLat = lat;
        const currentLon = lon;
        setLat(currentLat);
        setLon(currentLon);
        localStorage.setItem("cityCoords", JSON.stringify({ currentLat: currentLat, currentLon: currentLon }))
    }

    return (
        <Box sx={{ minWidth: 120. }}>
            <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                <InputLabel id="demo-simple-select-filled-label" sx={{
                    color: "white",
                    "&.Mui-focused": {
                        color: "white",
                    },
                    "&.Mui-error": {
                        color: "red",
                    },
                }}>{lang === "ar" ? "المدينة" : "City"}</InputLabel>
                <Select
                    labelId="demo-simple-select-filled-label"
                    id="demo-simple-select-filled"
                    value={age}
                    onChange={handleChange}
                    sx={{
                        color: "white",
                        "& .MuiSelect-icon": {
                            color: "white",
                        },
                        "&:before": {
                            borderBottom: "1px solid white",
                        },
                        "&:hover:not(.Mui-disabled):before": {
                            borderBottom: "2px solid white",
                        },
                        "&.Mui-focused:after": {
                            borderBottom: "2px solid white",
                        },
                    }}
                >
                    <MenuItem value={lang === "ar" ? "الرياض" : "Riyadh"} onClick={() => handleCity(24.7136, 46.6753)}>
                        {lang === "ar" ? "الرياض" : "Riyadh"}
                    </MenuItem>
                    <MenuItem value={lang === "ar" ? "مكة المكرمة" : "Makkah"} onClick={() => handleCity(21.42664, 39.82563)}>
                        {lang === "ar" ? "مكة المكرمة" : "Makkah"}
                    </MenuItem>
                    <MenuItem value={lang === "ar" ? "المدينة المنورة" : "Medina"} onClick={() => handleCity(24.4672, 39.6024)}>
                        {lang === "ar" ? "المدينة المنورة" : "Medina"}
                    </MenuItem>
                    <MenuItem value={lang === "ar" ? "القاهرة" : "Cairo"} onClick={() => handleCity(30.0444, 31.2357)}>
                        {lang === "ar" ? "القاهرة" : "Cairo"}
                    </MenuItem>
                </Select>
            </FormControl>
        </Box>
    )
}